import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ProfileComplete from "@/pages/ProfileComplete";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/profile/complete")({
  head: () => seoHead("/profile/complete"),
  component: () => (
    <AuthGate><ProfileComplete /></AuthGate>
  ),
});
